/**
 * FAQ
 * Close all other FAQs when one is opened
 */
const $faqs = document.querySelectorAll( '.faq__question' );

$faqs.forEach( ( $faq ) => {
    $faq.addEventListener( 'toggle', () => {
        if ( $faq.open ) {
            $faqs.forEach( ( $faqSiblings ) => {
                if ( $faqSiblings !== $faq ) {
                    $faqSiblings.open = false;
                }
            } );
        }
    } );
} );
